import { defineFcm } from '../shared/factory';

export const FCM_REVENUE_VICTORIOUS_PETITION_PROMOTION_ENABLED = defineFcm(
	'revenue_victorious_petition_promotion_enabled',
)
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'TBD',
		scope: 'corgi-front-end',
		context: 'petition page',
		description: 'Indicates whether to display a list of suggested victorious petitions on the petition page.',
		import: false,
	});
